import { useCountUp } from "./useCountUp";

/**
 * A number that runs up to its value (see useCountUp). The moving digits are
 * hidden from screen readers; they get the final value at once, prefixed
 * with `label` when given ("Сумма по стадии «Новая»: 2,3 млн ₽").
 */
export const CountUp = ({
  value,
  format = String,
  duration,
  label,
  className,
}: {
  value: number;
  format?: (value: number) => string;
  duration?: number;
  label?: string;
  className?: string;
}) => {
  const shown = useCountUp(value, duration);
  const running = format(shown);
  const final = format(value);
  return (
    <span className={className}>
      <span aria-hidden>{running}</span>
      <span className="sr-only">{label ? `${label}: ${final}` : final}</span>
    </span>
  );
};
